export default function Alpha(props) {
  return (
    <div
      style={{
        width: props?.width ? props.width : "135px",
        height: props?.height ? props.height : "27px",
        borderRadius: "5px",
        border: "solid 1.5px #ff9d00",
        backgroundColor: "#ff9d000c",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        userSelect: "none",
      }}
    >
      <p
        style={{
          fontFamily: "Overpass",
          fontSize: "12px",
          fontWeight: 600,
          color: "#ff9d00",
        }}
      >
        ✋ {props.t("alpha")}
      </p>
    </div>
  );
}
